import { Card, Checkbox, Button } from 'src/components/UIComponents'
import AppNavbar from 'src/components/Dashboard/Layout/AppNavbar/AppNavbar.vue'
import AppFooter from 'src/components/Dashboard/Layout/AppFooter/AppFooter.vue'
import messages from './Login.json'
const { detect } = require('detect-browser')

export default {
  name: 'Login',

  i18n: messages,

  components: {
    Card,
    AppNavbar,
    AppFooter,
    [Checkbox.name]: Checkbox,
    [Button.name]: Button,
  },

  data() {
    return {
      form: {
        identifiant: '',
        motDePasse: '',
        validations: {
          identifiant: { required: true },
          motDePasse: { required: true },
        },
      },
      controls: {
        loading: false,
      },
      recaptchaCheck: true,
    }
  },

  mounted() {
    // Raz des précédentes infos
    window.localStorage.clear()
    // render captcha with site key in env var
    window.grecaptcha.render('recaptcha', {
      'sitekey': process.env.VUE_APP_CAPTCHA_SITE_KEY,
      'theme': 'light'
    })
  },

  beforeDestroy() {
    this.closeMenu()
  },

  methods: {
    toggleNavbar() {
      document.body.classList.toggle('nav-open')
    },

    closeMenu() {
      document.body.classList.remove('nav-open')
      document.body.classList.remove('off-canvas-sidebar')
    },

    /**
     * validation recaptcha
     */
    validateRecaptcha() {
      // 1. si vide rien pas d'appel back utile
      if (!grecaptcha.getResponse()) {
        this.recaptchaCheck = false
        return
      }
      // 2. appel back pour validation recaptcha
      this.$axios.get(`/rest/public/bd/utilisateur/validate/captcha?request=${grecaptcha.getResponse()}`)
        .then(response => {
          // si ok => login process
          // sinon errror
          if (response.data.success) {
            this.recaptchaCheck = true
            this.processLogin()
          } else {
            this.recaptchaCheck = false
          }
        })
        .catch(error => {
          // cocher la case ou erreur technique
          const err = error.response.data
          if (!this.$val.isDefined(err.attributs) && !this.$val.isDefined(err.businessCode)) {
            this.$notify.error({
              title: this.$t('notifications.exceptions.title.erreur'),
              message: this.$t('notifications.exceptions.message.error'),
            })
          } else {
            this.$notify.error({
              title: this.$t('notifications.exceptions.title'),
              message: this.$t('notifications.exceptions.message.' + err.businessCode),
            })
          }
          // qlq soit le cas d'erreur => reset recaptcha
          this.recaptchaCheck = false
          window.grecaptcha.reset()
        })
    },

    login() {
      this.$validator.validateAll().then(isValid => {
        // Si la validation echoue : on arrete.
        if (!isValid) {
          return
        }
        // Validation captcha
        this.validateRecaptcha()
      })
    },

    /**
     * processus login
     */
    processLogin() {
      // Construction de la request
      const LoginRequestDTO = {
        identifiant: this.form.identifiant,
        motDePasse: this.form.motDePasse,
      }

      // Appel au WS d'authentification
      this.controls.loading = true
      this.$axios.post('/rest/public/bd/login', LoginRequestDTO).then(
        response => {
          window.localStorage.clear()
          localStorage.setItem('auth', btoa(LoginRequestDTO.identifiant + ':' + LoginRequestDTO.motDePasse))
          // On enregistre le log de connexion
          this.sendLog()
          this.success(response)
          this.controls.loading = false
        },
        error => {
          this.failed(error)
          this.controls.loading = false
        }
      )
    },

    success(response) {
      this.saveToken(response)
      this.$store.commit('authSuccess')
      this.$store.commit('setUser', response.data)
      localStorage.setItem('user', JSON.stringify(response.data))
      if (this.$router.history.current.query && this.$router.history.current.query.redirect) {
        this.$router.push(this.$router.history.current.query.redirect)
      } else {
        this.$router.push({ name: 'UserAcces' })
      }
    },

    failed(error) {
      console.log(error.response)
      // en cas de catch d'erreur on reset le captcha car il sera invalide pour la prochaine tentative de connexion
      window.grecaptcha.reset()
      let codeRetour = 404
      if (error.response && error.response.status) codeRetour = error.response.status
      this.$store.commit('authError', codeRetour)
      this.clearToken()
      switch (codeRetour) {
        case 401:
          this.$notify.error({
            title: this.$t('notifications.exceptions.title.erreur'),
            message: this.$t('notifications.exceptions.message.badCredentials'),
          })
          break
        case 404:
          this.$notify.error({
            title: this.$t('notifications.exceptions.title.erreur'),
            message: this.$t('notifications.exceptions.message.serverNotFound'),
          })
          break
        case 500:
          if (error.response.data.businessCode) {
            this.$notify.error({
              title: this.$t('notifications.exceptions.title.erreur'),
              message: this.$t('notifications.exceptions.message.' + error.response.data.businessCode),
            })
          } else {
            // Erreur générale
            this.$notify.error({
              title: this.$t('notifications.exceptions.title.erreur'),
              message: this.$t('notifications.exceptions.message.error'),
            })
          }
          break
        default:
          break
      }
    },

    /**
     * Sauvegarde les tokens d'authentification de la response vers le localstorage
     * @param {*} response
     */
    saveToken(response) {
      localStorage.setItem('accessToken', response.data.jwt.accessToken)
      localStorage.setItem('refreshToken', response.data.jwt.refreshToken)
      localStorage.setItem('expiresInMsec', response.data.jwt.expiresInMsec)
    },
    /**
     * Supprime les données du localStorage
     */
    clearToken() {
      localStorage.removeItem('accessToken')
      localStorage.removeItem('refreshToken')
      localStorage.removeItem('expiresInMsec')
    },

    /**
     * Permet d'enregistrer l'action CONNEXION  ( car le composant DashboardLayout n'est pas encore créé )
     * @param {} request
     */
    sendLog: function() {
      const browser = detect()
      let requestDTO = {
        nomLog: 'CONNEXION',
        nomNavigateur: browser.name,
        versionNavigateur: browser.version,
      }
      this.$axios.post('rest/bd/logs/', requestDTO)
    },
  },
}
